import { Icon } from '@scalis/components/src'
import { Avatar, ButtonIcon } from '~/scalis-components/core'

export interface ApproverItemProps {
  isApproverUser?: boolean
  fullName?: string
  timeStampText?: string
  signatureTag?: React.ReactNode
  signatureNote?: string
  customContent?: React.ReactNode
  isNotificationBellDisabled?: boolean
  onNotificationBellClick?: () => void
}

export function ApproverItem({
  isApproverUser,
  fullName,
  timeStampText,
  signatureTag,
  signatureNote,
  customContent,
  isNotificationBellDisabled,
  onNotificationBellClick,
}: ApproverItemProps) {
  return (
    <div className='flex flex-col gap-2'>
      <div className='flex items-center justify-between w-full'>
        <ApproverInfo
          isApproverUser={isApproverUser}
          fullName={fullName}
          timeStampText={timeStampText}
          customContent={customContent}
        />

        <div className='flex items-center gap-2'>
          {!customContent && timeStampText && (
            <p className='body-small-basic text-neutral-secondary @max-[500px]:hidden'>{timeStampText}</p>
          )}

          {!customContent && signatureTag && signatureTag}

          {customContent && <div className='@max-[500px]:hidden'>{customContent}</div>}

          <ButtonIcon
            icon='fa-regular fa-bell'
            disabled={isNotificationBellDisabled}
            onClick={onNotificationBellClick}
            data-testid='button-icon'
          />
        </div>
      </div>

      {signatureNote && <p className='body-small-basic text-neutral-secondary'>{`"${signatureNote}"`}</p>}
    </div>
  )
}

export interface ApproverInfoProps {
  isApproverUser?: boolean
  fullName?: string
  timeStampText?: string
  customContent?: React.ReactNode
}

export function ApproverInfo({ isApproverUser, fullName, timeStampText, customContent }: ApproverInfoProps) {
  return (
    <div className='flex @max-[500px]:items-start @min-[500px]:items-center gap-2'>
      {isApproverUser ? (
        <Avatar fullName={fullName ?? ''} />
      ) : (
        <div className='rounded-full bg-neutral-20 p-1 w-8 h-8 '>
          <Icon
            className='fa-regular fa-users text-sm text-icon-neutral-10 text-center'
            data-testid='icon'
          />
        </div>
      )}
      <div className='flex flex-col'>
        <p className='body-small-basic'>{fullName}</p>

        <div className='@min-[500px]:hidden'>
          {customContent ? customContent : <p className='body-small-basic text-neutral-secondary'>{timeStampText}</p>}
        </div>
      </div>
    </div>
  )
}
